import { render } from "./GrantCriteria.vue?vue&type=template&id=7fee16ae&scoped=true&ts=true"
import script from "./GrantCriteria.vue?vue&type=script&lang=ts"
export * from "./GrantCriteria.vue?vue&type=script&lang=ts"

import "./GrantCriteria.vue?vue&type=style&index=0&id=7fee16ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fee16ae"]])

export default __exports__